import { useMemo } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

const useShopstoryData = (locale: string, id: string) => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allContentfulShopstoryBlock {
        edges {
          node {
            id
            contentful_id
            node_locale
            fields {
              shopStoryData {
                content
                meta
              }
            }
          }
        }
      }
    }
  `);

  return useMemo(() => {
    const regex = new RegExp(locale, 'gi');

    return (
      data.allContentfulShopstoryBlock.edges.find(
        ({ node }) => node.contentful_id === id && regex.test(node.node_locale)
      )?.node ||
      data.allContentfulShopstoryBlock.edges.find(
        ({ node }) => node.contentful_id === id && node.node_locale === 'en'
      )?.node ||
      {}
    );
  }, [locale]);
};

export default useShopstoryData;
